import gql from 'graphql-tag'

// Queries

export const FindTagsQuery = gql`
query tagCollection($keyword: String!) {
		tagCollection(filter: { title: { ilike: $keyword   } }) {
			edges{node {
					id
					title
				}}
			
		}
	}
`

// Mutations
export const AppreciateTagMutation = gql`
	mutation appreciate(
		$language: String!
		$tagId: String!
		$articleId: String!
	) {
		appreciate(language: $language, tagId: $tagId, articleId: $articleId) {
		edges{node{	status
			error}}
		}
	}
`
